import React from 'react';
import { Card, OverlayTrigger, Tooltip } from 'react-bootstrap';
import {  FaTrash } from 'react-icons/fa';
import GlobalButton from '../../../utils/GlobalButton';
import dashboard from '../../../css/dashboard.module.css'
import { formatDate } from '../../shared/Constant';
import { FaRegCircleStop } from "react-icons/fa6";
import { MdNotStarted } from "react-icons/md";
import { CiSettings } from 'react-icons/ci';
import { useNavigate } from 'react-router-dom';


const RepublishCard = ({id,name,title,createdDate,modifiedDate,showAction=false,showFooter=false,navigateeditIcon,handleDelete=null,handlePublish=null,tabValue="all",stopLiveBots,startLiveBots,handleRepublish,bot_id,bot_status,navigatedBotConfig}) => {
          const navigate = useNavigate();
  return (
    <Card border="light" className="mb-3 shadow-sm w-100 " >
      {/* Header */}
      <Card.Header className="d-flex justify-content-between align-items-center">
        <span className="fw-bold">{name}</span>
        <div>
         
         {showAction && tabValue==="livebots" && 
                 <CiSettings role="button" className='me-3' size={20} onClick={()=>{
                   if(navigatedBotConfig){
                     navigate(navigatedBotConfig)
                   }
                 }}/>
         
         }
  {bot_status === "running" ? (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip>Stop Bot</Tooltip>}
            >
              <span className="me-2">
                <FaRegCircleStop
                  className="text-success pulse-animation" // Green color + animation for running
                  size={22}
                  onClick={() => stopLiveBots(bot_id)}
                  style={{ cursor: 'pointer' }}
                />
              </span>
            </OverlayTrigger>
          ) : (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip>Start Bot</Tooltip>}
            >
              <span className="me-2">
                <MdNotStarted
                  className="text-secondary" // Gray color for stopped
                  size={22}
                  onClick={() => startLiveBots(bot_id)}
                  style={{ cursor: 'pointer' }}
                />
              </span>
            </OverlayTrigger>
          )}


          <FaTrash className="ps-2 text-danger" role="button"  size={22} onClick={()=>handleDelete(id)}/>
        </div>
        
      </Card.Header>

      {/* Body */}
      <Card.Body >
        <Card.Text >
         {title}
        </Card.Text>
        <div className='text-muted small'>
            <div>Last Edited By: <span className={`fw-medium ${dashboard.datefont}`} >{formatDate(modifiedDate)}</span></div>
            <div>Creation Date: <span className={`fw-medium ${dashboard.datefont}`}>{formatDate(createdDate)}</span></div>
        </div>
      </Card.Body>

      {/* Footer */}
      {showFooter &&
      <Card.Footer className="d-flex justify-content-end bg-white border-top-0">
        {/* <Button variant="primary" size="sm">Publish</Button> */}
         <GlobalButton children={"RePublish"}  size="sm" className={`${dashboard.backgroundColor} ${dashboard.nohover}`}
          variant="contained"
          onClick={() =>handleRepublish(id,name,title)}
        />
      </Card.Footer>
      }
    </Card>
    
  );
};

export default RepublishCard;
